// extracted by mini-css-extract-plugin
module.exports = {"InfoCell":"ArchivedTeamList_InfoCell__2qgPr","IconContainer":"ArchivedTeamList_IconContainer__1xXrx"};